import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface ExcelResponse {
    all_cnt: number;
    success_cnt: number;
    err_cnt: number;
    err_line: { line: number; name: string; value: string; errmsg: string }[];
    message: string;
}
export const usePostExcelFile = (successCallback?: (data: ExcelResponse) => void) => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async (file: File) => {
            const formData = new FormData();
            formData.append("excel_file", file);

            const response = await axios.post(enum_api_uri.post_excel, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data.data as ExcelResponse;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["getExcelData"] });
            successCallback?.(data);
        },
    });
};
